import { LinkOutbound } from '@/components/common/Link'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type ComboBaseType } from '@/defs/combo'
import { formatFullNumber } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonDonutPercentage } from '../../StatCommon/StatCommonDonutPercentage/StatCommonDonutPercentage'

type Props = {
  combo: ComboBaseType
}

export const StatComboInclusion = ({ combo }: Props) => {
  const percentage = (combo.numDecks || 0) / (combo.potentialDecks || 1)

  const popover = (
    <>
      <h2>
        <IconWithLabel iconBefore='percent'>Inclusion</IconWithLabel>
      </h2>
      <p>
        This combo is included in <strong>{formatFullNumber(combo.numDecks)}</strong> of{' '}
        <strong>{formatFullNumber(combo.potentialDecks)}</strong>{' '}
        <LinkOutbound href='/faq#potential-decks'>potential decks</LinkOutbound>.
      </p>
    </>
  )

  return (
    <StatCommonBox label='Inclusion' popover={popover}>
      <StatCommonDonutPercentage percentage={percentage} />
    </StatCommonBox>
  )
}
